import { type Sleep, defaultSleep } from "./sleep";

const RETRY_DELAYS_MS = [2000, 4000];

export const withRetries = async <T>(
	attempt: () => Promise<T | null>,
	sleep: Sleep = defaultSleep,
): Promise<T | null> => {
	for (let i = 0; i <= RETRY_DELAYS_MS.length; i++) {
		const result = await attempt();
		if (result !== null) {
			return result;
		}
		if (i < RETRY_DELAYS_MS.length) {
			await sleep(RETRY_DELAYS_MS[i]);
		}
	}
	return null;
};
